import {GhostButton} from "@bolteu/clay-react";
import {lightContent} from "config/themeV2";
import styled from "styled-components";

export const AttachmentContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 8px 12px 16px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.02); /* stylelint-disable-line color-function-notation */ /* todo SUPX-87 */
    }
`;

export const TextColumn = styled.div`
    display: flex;
    flex-direction: column;
    flex: 0 0 75%;
    max-width: 75%;
`;

export const IconColumn = styled.div`
    display: flex;
    align-items: center;
`;

export const FileName = styled.div`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 95%;
    direction: rtl;
    text-align: left;
`;

export const FileSubtitle = styled.div<{$error?: boolean}>`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    ${({$error}) => $error && `color: ${lightContent["danger-primary"]};`}
`;

export const AttachmentList = styled.div`
    padding-top: 20px;
`;

export const DeleteButton = styled(GhostButton)`
    height: 24px;
    width: 24px;
    min-width: 24px;
    padding: 0;
    margin-right: 8px;
`;
